/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {Observable} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {AdnApiClientService} from '../../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class PoliticalAdsApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  getHtmlTemplate(): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['politicalads', 'template', 'transparency-notice'])
    });
  }

  getRenderDsaTemplate(): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['politicalads', 'template', 'transparency-overlay'])
    });
  }

  renderHtml(params: any): Observable<string> {
    return this.client.request<string>({
      method: 'POST',
      url: this.apiConfig.getVersionedUri(['politicalads', 'html', 'render']),
      headers: {Accept: 'text/html'},
      responseType: 'text',
      body: _.pickBy({
        n: params.n,
        li: params.li,
        p: params.p,
        template: params.template
      }, (value: any) => value !== undefined && value !== null && value !== '')
    });
  }
}
